var moment = require('moment')

const priceFormatter = new Intl.NumberFormat(global.dataInit.culture, {
  style: 'currency',
  minimumFractionDigits: 2,
  currency: 'EUR'
})

export default class {
  constructor (booking) {
    this.booker = booking.booker
    this.bookingDate = moment(booking.bookingDate, 'YYYYMMDDHHmmss')
    this.commandNumber = booking.commandNumber
    this.id = booking.id
    this.accomodation = booking.accomodation
    this.price = booking.price
    this.deposit = booking.deposit
    this.tripEndDate = moment(booking.tripEndDate, 'YYYYMMDD')
    this.tripStartDate = moment(booking.tripStartDate, 'YYYYMMDD')
    this.status = booking.status
    this.hasPaymentInfo = booking.hasPaymentInfo
  }

  get formatedTripStartDate () {
    return this.tripStartDate.format('L')
  }

  get formatedTripEndDate () {
    return this.tripEndDate.format('L')
  }

  get formatedBookingDate () {
    return this.bookingDate.format('L') + ' ' + this.bookingDate.format('LT')
  }

  get formatedPrice () {
    return priceFormatter.format(this.price)
  }

  get formatedDeposit () {
    if (this.deposit && this.deposit !== null) {
      return priceFormatter.format(this.deposit)
    } else {
      return ''
    }
  }

  get website () {
    if (this.site === 'fr') {
      return 'CLuxe'
    } else {
      return 'CLuxury (' + this.site + ')'
    }
  }

  get statusIcon () {
    switch (this.status) {
      case 0:
        return 'hourglass_empty'
      case 1:
        return 'done'
      default :
        return 'highlight_off'
    }
  }
}
